<div class="grid">
	<div [class]="actionLayoutButtons('left')">
		<p-button id="addMtmaModule" label="{{ 'ADD_MODULE' | translate }}" (click)="clickAddModule()"
			[disabled]="disableAddModule()" icon="pi cm-plus" [rounded]="false" [text]="true" severity="primary"
			styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>
	<div [class]="actionLayoutButtons('center')">
		<div>
			<p-button label="{{ 'UPDATE_FIRWARE_MTMA_TIMESLOTS' | translate }}" (click)="clickUpdateFirmwareTimeslots()"
				[disabled]="offline() || onFirmwareUpdate()" icon="pi cm-update-firmware"
				[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary">
			</p-button>
		</div>
	</div>
	<div [class]="actionLayoutButtons('right')">
		<p-button *ngIf="mtmaFirmwareUpdates.length > 0" label="{{ 'FW_VERSION_UPDATE' | translate }}" (click)="clickUpdateFirmware()"
			[disabled]="offline() || onFirmwareUpdate()"  icon="pi cm-update-firmware"
			[rounded]="false" [text]="true" severity="warning" styleClass="font-bold border-yellow-600">
		</p-button>
	</div>
	<div class="col-12">
		<div class="card border-round flex align-items-center justify-content-center">
			<p-table #tableModulesList [value]="mtmaModules" [reorderableColumns]="false" (onRowReorder)="drop($event)"
				class="w-full" responsiveLayout="stack">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th>
						</th>
						<th></th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'TYPE' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'FW_VERSION' | translate }}</div>
						</th>
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-module let-columns="columns" let-index="rowIndex">
					<tr [pReorderableRow]="index">
						<td>
							<span class="pi cm-bars text-2xl" pReorderableRowHandle pTooltip="{{ 'MOVE_MODULE' | translate}}"
								*ngIf="!disableEditModule() && index !== 0"></span>
						</td>
						<td>
							<div class="flex align-items-center justify-content-center w-full">
								<img [src]="imageSource(module)" alt="" width="120px">
							</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'TYPE' | translate }}</span>
							{{ getModuleName(module) | translate }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							{{ module.Name }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'FW_VERSION' | translate }}</span>
							<div class="flex flex-column gap-3">
								<div class="flex flex-row justify-content-center align-items-center gap-1">
									<span>{{'FWVersion' | translate }}: {{module.FWVersion}}</span>
									<p-button *ngIf="releaseNoteAvailableFWVersion(module).length > 0"
										pTooltip="{{'RELEASE_NOTE_DEVICE' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
										size="large" (click)="showReleaseNoteFWVersion(module)" [rounded]="false" [text]="true"
										severity="primary">
									</p-button>
								</div>
								<div *ngIf="visibleFWVersionBl(module)">
									<span>{{'FWVersionBL' | translate }}:
										{{module.FWVersionBL}}</span>
								</div>
								<div *ngIf="visibleFWVersionLte(module)"
									class="flex flex-row justify-content-center align-items-center gap-1">
									<span>{{'FWVersionLte' | translate }}:
										{{module.FWVersionLTE}}</span>
									<p-button *ngIf="releaseNoteAvailableFWVersionLte(module).length > 0"
										pTooltip="{{'RELEASE_NOTE_DEVICE' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
										size="large" (click)="showReleaseNoteFWVersionLte(module)" [rounded]="false" [text]="true"
										severity="primary">
									</p-button>
								</div>
								<div *ngIf="visibleFWVersionLte(module)"
									class="flex flex-row justify-content-center align-items-center gap-2">
									<div>{{'UPDATE_FIRWARE_MTMA_TIMESLOTS' | translate }}:</div>
									<p-tag *ngIf="mtmaFwAutoUpdateTimeslot" icon="pi cm-check" severity="success" [value]="('MTMA_FW_AUTOUPDATE_STATUS_ON' | translate)"></p-tag>
									<p-tag *ngIf="!mtmaFwAutoUpdateTimeslot" icon="pi cm-cancel" severity="danger" [value]="('MTMA_FW_AUTOUPDATE_STATUS_OFF' | translate)"></p-tag>
								</div>
							</div>
						</td>
						<td>
							<span class="p-column-title font-semibold"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" id="buttonModuleEdit-{{module.Name}}"
									[disabled]="disableEditModule()" tooltipPosition="bottom" icon="pi cm-cog" size="large"
									(click)="editModule(module)" [rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" id="buttonModuleDelete-{{module.Name}}"
									[disabled]="isModuleNotDelete(module) || disableEditModule()" tooltipPosition="bottom"
									icon="pi cm-trash" size="large" (click)="deleteModule(module)" [rounded]="false" [text]="true"
									severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>